import { type ReactNode } from 'react'
import { Link } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
import { cn } from '#app/utils/misc.tsx'

/**
 * The muted "back to …" link of a marketing page: arrow-left icon plus an
 * already-translated label. Each site sets its own margin via `className`.
 */
export function BackLink({
	to,
	children,
	className,
}: {
	to: string
	children: ReactNode
	className?: string
}) {
	return (
		<Link
			to={to}
			className={cn(
				'text-body-sm text-muted-foreground hover:text-foreground focus-cosy inline-flex items-center transition-colors',
				className,
			)}
		>
			<Icon name="arrow-left" className="mr-1" aria-hidden="true" />
			{children}
		</Link>
	)
}
